export default __webpack_public_path__ + "static/media/varsam.7c1e1760.png";